import React from 'react';
import { Stack, Text } from '@moda/om';
import CheckmarkIcon from '@moda/icons/checkmark-16';
import { LineItem, useCart } from '../../../hooks/useCart';

import './LineItemPromo.scss';

type Props = {
  item: LineItem;
};

export const LineItemPromo: React.FC<Props> = ({
  item: {
    attributes: { promotionApplicableMessage }
  }
}) => {
  const {
    cart: {
      attributes: { giftCode }
    }
  } = useCart();
  if (!promotionApplicableMessage || !giftCode) return null;
  const promoApplied = promotionApplicableMessage.toLowerCase() === 'promo applied';

  return (
    <Stack space={1} direction="horizontal">
      {promoApplied && (
        <div className="LineItemPromo__promo-checkmark">
          <CheckmarkIcon color="rgb(180, 60, 160)" />
        </div>
      )}
      <Text
        className="LineItemPromo__promo-text"
        treatment="bold1"
        color={promoApplied ? 'dark-fuchsia' : 'code-red'}
      >
        {promotionApplicableMessage}
      </Text>
    </Stack>
  );
};
